module.exports = __webpack_public_path__ + "static/3b-9da78d0355d58bf82f7f0e978a561023.webp";